var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "investi-print-pdf",
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "exampleModalLabel",
        "aria-hidden": "true",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog wider-1 wider-print9",
          attrs: { role: "document" },
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _vm.isrefreshinv
              ? _c("div", { attrs: { id: "cover-spin" } })
              : _vm._e(),
            _c("div", { staticClass: "modal-body p-0" }, [
              _c("div", { staticClass: "pb-3 pr-5 pl-5 pt-3" }, [
                _c(
                  "div",
                  {
                    staticClass: "row",
                    staticStyle: { "max-width": "898px", margin: "0 auto" },
                  },
                  [
                    _c("div", { staticClass: "col-md-12 padr-0" }, [
                      _vm.showhideemailpopup
                        ? _c("div", [
                            _c(
                              "div",
                              {
                                staticClass: "modal fade",
                                attrs: {
                                  id: "Sendemailin",
                                  tabindex: "-1",
                                  role: "dialog",
                                  "aria-labelledby": "exampleModalCenterTitle",
                                  "aria-hidden": "true",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "modal-dialog grt-md",
                                    staticStyle: {
                                      width: "570px",
                                      background: "#fff",
                                      "border-radius": "3px",
                                      "-webkit-border-radius": "3px",
                                    },
                                    attrs: { role: "document" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "modal-content",
                                        staticStyle: { padding: "20px 50px" },
                                      },
                                      [
                                        _vm._m(0),
                                        _c(
                                          "div",
                                          { staticClass: "modal-body" },
                                          [
                                            _c(
                                              "ul",
                                              {
                                                staticClass: "list-select",
                                                staticStyle: {
                                                  "margin-bottom": "0px",
                                                },
                                              },
                                              [
                                                _vm._l(
                                                  _vm.emaillist,
                                                  function (item) {
                                                    return _c(
                                                      "li",
                                                      {
                                                        key: item,
                                                        staticClass:
                                                          "data-hold",
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(_vm._s(item)),
                                                        ]),
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href: "#",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.removeEmail(
                                                                  item
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_vm._v("X")]
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                _c("li", [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.customemail,
                                                        expression:
                                                          "customemail",
                                                      },
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "text",
                                                      placeholder:
                                                        "Type in email address & press enter",
                                                    },
                                                    domProps: {
                                                      value: _vm.customemail,
                                                    },
                                                    on: {
                                                      keyup: function ($event) {
                                                        if (
                                                          !$event.type.indexOf(
                                                            "key"
                                                          ) &&
                                                          _vm._k(
                                                            $event.keyCode,
                                                            "enter",
                                                            13,
                                                            $event.key,
                                                            "Enter"
                                                          )
                                                        ) {
                                                          return null
                                                        }
                                                        return _vm.addemail(
                                                          _vm.customemail
                                                        )
                                                      },
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.customemail =
                                                          $event.target.value
                                                      },
                                                    },
                                                  }),
                                                ]),
                                              ],
                                              2
                                            ),
                                            _vm.errorsemail
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      color:
                                                        "rgba(243, 69, 58, 0.8)",
                                                      "font-size": "13px",
                                                      "font-weight": "500",
                                                      display:
                                                        "block !important",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.errorsemail)
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _vm.emaillist &&
                                        _vm.emaillist.length > 0
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "modal-footer",
                                                staticStyle: {
                                                  "padding-top": "0px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "primary-btn ripple pull-right",
                                                    attrs: {
                                                      type: "button",
                                                      "data-dismiss": "modal",
                                                      "aria-label": "Close",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.senddetailsoveremail()
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Send")]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.getPdfUrl) +
                          " " +
                          _vm._s(_vm.getdatafromparent) +
                          "\n              "
                      ),
                      _c(
                        "ul",
                        { staticClass: "print-export new-rule-border" },
                        [
                          _c(
                            "li",
                            {
                              staticStyle: {
                                "border-right": "1px solid #eeeeee",
                              },
                            },
                            [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.onPrintVitals()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "i",
                                    { staticClass: "material-icons print" },
                                    [_vm._v("print")]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c("li", { staticClass: "mt-1" }, [
                            _c(
                              "span",
                              { staticStyle: { "margin-right": "10px" } },
                              [
                                _vm.printable_headerinves
                                  ? _c("span", [_vm._v(_vm._s(_vm.$t("Hide")))])
                                  : _vm._e(),
                                !_vm.printable_headerinves
                                  ? _c("span", [_vm._v(_vm._s(_vm.$t("Show")))])
                                  : _vm._e(),
                                _vm._v(
                                  _vm._s(_vm.$t("Header")) +
                                    "\n                  "
                                ),
                              ]
                            ),
                            _c(
                              "label",
                              {
                                staticClass: "container customcheck pr-1",
                                staticStyle: { width: "auto" },
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.printable_headerinves,
                                      expression: "printable_headerinves",
                                    },
                                  ],
                                  attrs: {
                                    type: "checkbox",
                                    id: "printableheaderinves",
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.printable_headerinves
                                    )
                                      ? _vm._i(
                                          _vm.printable_headerinves,
                                          null
                                        ) > -1
                                      : _vm.printable_headerinves,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.storeprintableheader()
                                    },
                                    change: function ($event) {
                                      var $$a = _vm.printable_headerinves,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.printable_headerinves =
                                              $$a.concat([$$v]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.printable_headerinves = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.printable_headerinves = $$c
                                      }
                                    },
                                  },
                                }),
                                _c("span", { staticClass: "checkmark" }),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _vm._m(1),
                    ]),
                    _vm.vitalsobj ||
                    _vm.vitalsobj != null ||
                    _vm.vitalsobj != undefined
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              width: "100%",
                              "margin-top": "10px",
                            },
                            style: { fontFamily: this.$t("fontfam") },
                            attrs: { id: "modalViewvitalssPrint" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.getsignaturepath) +
                                " " +
                                _vm._s(_vm.getDownloadUrl) +
                                "\n              "
                            ),
                            _vm.tenantId ==
                            "44acd54f-5f3b-4567-a1a0-ca8e25d8ddc9"
                              ? _c(
                                  "div",
                                  {
                                    class: _vm.printable_headerinves
                                      ? "page-header"
                                      : "no-header",
                                  },
                                  [
                                    _vm.printable_headerinves
                                      ? _c(
                                          "table",
                                          {
                                            staticStyle: {
                                              "border-bottom":
                                                "1px solid #d4d5d7",
                                              "margin-top": "15px",
                                            },
                                            attrs: {
                                              width: "100%",
                                              cellspacing: "0",
                                              cellpadding: "0",
                                              border: "0",
                                            },
                                          },
                                          [
                                            _c("tr", [
                                              _c("td", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "clinic-logo-hold",
                                                  },
                                                  [
                                                    _vm.ClicnicUrllogo != "" &&
                                                    _vm.printable_headerinves
                                                      ? _c("img", {
                                                          attrs: {
                                                            src: _vm.ClicnicUrllogo,
                                                            height: "160px",
                                                            width: "Auto",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]),
                                            ]),
                                            _c(
                                              "tr",
                                              {
                                                staticStyle: {
                                                  padding: "0px 40px",
                                                  "background-color":
                                                    "rgb(255, 255, 255)",
                                                },
                                              },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "wrapper1",
                                                    staticStyle: {
                                                      padding:
                                                        "15px 30px 10px 0",
                                                    },
                                                    attrs: {
                                                      width: "50%",
                                                      valign: "top",
                                                      align: "left",
                                                    },
                                                  },
                                                  [
                                                    _vm.vitalsobj.businesssetup
                                                      ? _c("table", {
                                                          attrs: {
                                                            width: "100%",
                                                            cellspacing: "0",
                                                            cellpadding: "0",
                                                            border: "0",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                ),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "wrapper1",
                                                    staticStyle: {
                                                      "padding-bottom": "10px",
                                                    },
                                                    attrs: {
                                                      width: "50%",
                                                      valign: "top",
                                                      "text-align": "center",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "table",
                                                      {
                                                        attrs: {
                                                          width: "100%",
                                                          cellspacing: "0",
                                                          cellpadding: "0",
                                                          border: "0",
                                                        },
                                                      },
                                                      [
                                                        _c("tr", [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticStyle: {
                                                                display:
                                                                  "block",
                                                              },
                                                              attrs: {
                                                                valign: "top",
                                                                align: "right",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "#212529",
                                                                    "font-size":
                                                                      "14px",
                                                                    "font-weight":
                                                                      "500",
                                                                    "line-height":
                                                                      "140%",
                                                                  },
                                                                  attrs: {
                                                                    align:
                                                                      "right",
                                                                  },
                                                                },
                                                                [
                                                                  _vm.Doctordetailsshow ==
                                                                    true &&
                                                                  _vm.vitalsobj
                                                                    .staffDetails
                                                                    .title &&
                                                                  _vm.vitalsobj
                                                                    .staffDetails
                                                                    .first_name
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm
                                                                                .vitalsobj
                                                                                .staffDetails
                                                                                .title
                                                                            ) +
                                                                              "\n                                " +
                                                                              _vm._s(
                                                                                _vm
                                                                                  .vitalsobj
                                                                                  .staffDetails
                                                                                  .first_name
                                                                              ) +
                                                                              " " +
                                                                              _vm._s(
                                                                                _vm
                                                                                  .vitalsobj
                                                                                  .staffDetails
                                                                                  .last_name ==
                                                                                  null
                                                                                  ? ""
                                                                                  : _vm
                                                                                      .vitalsobj
                                                                                      .staffDetails
                                                                                      .last_name
                                                                              )
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ]
                                                              ),
                                                              _vm.Doctordetailsshow ==
                                                              true
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          color:
                                                                            "#212529",
                                                                          "font-size":
                                                                            "14px",
                                                                          "font-weight":
                                                                            "500",
                                                                          "line-height":
                                                                            "140%",
                                                                          width:
                                                                            "100%",
                                                                          display:
                                                                            "block",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.qualification
                                                                        )
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "#212529",
                                                                    "font-size":
                                                                      "14px",
                                                                    "font-weight":
                                                                      "500",
                                                                    "line-height":
                                                                      "140%",
                                                                  },
                                                                  attrs: {
                                                                    align:
                                                                      "right",
                                                                  },
                                                                },
                                                                [
                                                                  _vm.vitalsobj &&
                                                                  _vm.vitalsobj
                                                                    .staffDetails &&
                                                                  _vm.vitalsobj
                                                                    .staffDetails
                                                                    .category_list
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.processItems
                                                                            )
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ]
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "#212529",
                                                                    "font-size":
                                                                      "14px",
                                                                    "font-weight":
                                                                      "500",
                                                                    "line-height":
                                                                      "140%",
                                                                  },
                                                                  attrs: {
                                                                    align:
                                                                      "right",
                                                                  },
                                                                },
                                                                [
                                                                  _vm.Doctordetailsshow ==
                                                                    true &&
                                                                  _vm.vitalsobj
                                                                    .staffDetails &&
                                                                  _vm.vitalsobj
                                                                    .staffDetails
                                                                    .registration_number
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm
                                                                                .vitalsobj
                                                                                .staffDetails
                                                                                .registration_number
                                                                            )
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ]
                                                              ),
                                                              _c("br"),
                                                              _vm.Doctordetailsshow ==
                                                                true &&
                                                              _vm.location_tephonedetails
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          color:
                                                                            "#212529",
                                                                          "font-size":
                                                                            "14px",
                                                                          "font-weight":
                                                                            "500",
                                                                          "line-height":
                                                                            "140%",
                                                                        },
                                                                      attrs: {
                                                                        align:
                                                                          "right",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.location_tephonedetails
                                                                            )
                                                                          ),
                                                                          _c(
                                                                            "br"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._m(2),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              : _c(
                                  "HeaderWrapper",
                                  {
                                    class: _vm.printable_headerinves
                                      ? "page-header"
                                      : "no-header",
                                    attrs: {
                                      printable: _vm.printable_headerinves,
                                    },
                                  },
                                  [
                                    _vm.printable_headerinves
                                      ? _c(
                                          "table",
                                          {
                                            staticStyle: {
                                              "border-bottom":
                                                "1px solid #d4d5d7",
                                              "margin-top": "15px",
                                            },
                                            attrs: {
                                              width: "100%",
                                              cellspacing: "0",
                                              cellpadding: "0",
                                              border: "0",
                                            },
                                          },
                                          [
                                            _c("tr", [
                                              _c("td", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "clinic-logo-hold",
                                                  },
                                                  [
                                                    _vm.ClicnicUrllogo != "" &&
                                                    _vm.printable_headerinves
                                                      ? _c("img", {
                                                          attrs: {
                                                            src: _vm.ClicnicUrllogo,
                                                            height: "60px",
                                                            width: "Auto",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]),
                                            ]),
                                            _c(
                                              "tr",
                                              {
                                                staticStyle: {
                                                  padding: "0px 40px",
                                                  "background-color":
                                                    "rgb(255, 255, 255)",
                                                },
                                              },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "wrapper1",
                                                    staticStyle: {
                                                      padding:
                                                        "15px 30px 10px 0",
                                                    },
                                                    attrs: {
                                                      width: "50%",
                                                      valign: "top",
                                                      align: "left",
                                                    },
                                                  },
                                                  [
                                                    _vm.vitalsobj.businesssetup
                                                      ? _c(
                                                          "table",
                                                          {
                                                            attrs: {
                                                              width: "100%",
                                                              cellspacing: "0",
                                                              cellpadding: "0",
                                                              border: "0",
                                                            },
                                                          },
                                                          [
                                                            _vm.vitalsobj
                                                              .businesssetup
                                                              ? _c("tr", [
                                                                  _vm.vitalsobj
                                                                    .businesssetup
                                                                    .location
                                                                    ? _c(
                                                                        "td",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              display:
                                                                                "block",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              valign:
                                                                                "top",
                                                                              align:
                                                                                "left",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm
                                                                            .vitalsobj
                                                                            .businesssetup
                                                                            .name
                                                                            ? _c(
                                                                                "span",
                                                                                {
                                                                                  domProps:
                                                                                    {
                                                                                      innerHTML:
                                                                                        _vm._s(
                                                                                          _vm
                                                                                            .vitalsobj
                                                                                            .businesssetup
                                                                                            .name
                                                                                        ),
                                                                                    },
                                                                                }
                                                                              )
                                                                            : _vm._e(),
                                                                          _c(
                                                                            "br"
                                                                          ),
                                                                          _vm
                                                                            .vitalsobj
                                                                            .businesssetup
                                                                            .location &&
                                                                          _vm
                                                                            .vitalsobj
                                                                            .businesssetup
                                                                            .location
                                                                            .address
                                                                            ? _c(
                                                                                "span",
                                                                                {
                                                                                  staticStyle:
                                                                                    {
                                                                                      color:
                                                                                        "#333333",
                                                                                      "font-size":
                                                                                        "14px",
                                                                                      "font-weight":
                                                                                        "normal",
                                                                                      "line-height":
                                                                                        "140%",
                                                                                    },
                                                                                  domProps:
                                                                                    {
                                                                                      innerHTML:
                                                                                        _vm._s(
                                                                                          _vm
                                                                                            .vitalsobj
                                                                                            .businesssetup
                                                                                            .location
                                                                                            .address
                                                                                        ),
                                                                                    },
                                                                                }
                                                                              )
                                                                            : _vm._e(),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ])
                                                              : _vm._e(),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "wrapper1",
                                                    staticStyle: {
                                                      "padding-bottom": "10px",
                                                    },
                                                    attrs: {
                                                      width: "50%",
                                                      valign: "top",
                                                      "text-align": "center",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "table",
                                                      {
                                                        attrs: {
                                                          width: "100%",
                                                          cellspacing: "0",
                                                          cellpadding: "0",
                                                          border: "0",
                                                        },
                                                      },
                                                      [
                                                        _c("tr", [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticStyle: {
                                                                display:
                                                                  "block",
                                                              },
                                                              attrs: {
                                                                valign: "top",
                                                                align: "right",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "#212529",
                                                                    "font-size":
                                                                      "14px",
                                                                    "font-weight":
                                                                      "500",
                                                                    "line-height":
                                                                      "140%",
                                                                  },
                                                                  attrs: {
                                                                    align:
                                                                      "right",
                                                                  },
                                                                },
                                                                [
                                                                  _vm.Doctordetailsshow ==
                                                                    true &&
                                                                  _vm.vitalsobj
                                                                    .staffDetails
                                                                    .title &&
                                                                  _vm.vitalsobj
                                                                    .staffDetails
                                                                    .first_name
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm
                                                                                .vitalsobj
                                                                                .staffDetails
                                                                                .title
                                                                            ) +
                                                                              "\n                                " +
                                                                              _vm._s(
                                                                                _vm
                                                                                  .vitalsobj
                                                                                  .staffDetails
                                                                                  .first_name
                                                                              ) +
                                                                              " " +
                                                                              _vm._s(
                                                                                _vm
                                                                                  .vitalsobj
                                                                                  .staffDetails
                                                                                  .last_name ==
                                                                                  null
                                                                                  ? ""
                                                                                  : _vm
                                                                                      .vitalsobj
                                                                                      .staffDetails
                                                                                      .last_name
                                                                              )
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ]
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "#212529",
                                                                    "font-size":
                                                                      "14px",
                                                                    "font-weight":
                                                                      "500",
                                                                    "line-height":
                                                                      "140%",
                                                                    width:
                                                                      "100%",
                                                                    display:
                                                                      "block",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.qualification
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "#212529",
                                                                    "font-size":
                                                                      "14px",
                                                                    "font-weight":
                                                                      "500",
                                                                    "line-height":
                                                                      "140%",
                                                                  },
                                                                  attrs: {
                                                                    align:
                                                                      "right",
                                                                  },
                                                                },
                                                                [
                                                                  _vm.vitalsobj &&
                                                                  _vm.vitalsobj
                                                                    .staffDetails &&
                                                                  _vm.vitalsobj
                                                                    .staffDetails
                                                                    .category
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm
                                                                                .vitalsobj
                                                                                .staffDetails
                                                                                .category
                                                                            )
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ]
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "#212529",
                                                                    "font-size":
                                                                      "14px",
                                                                    "font-weight":
                                                                      "500",
                                                                    "line-height":
                                                                      "140%",
                                                                  },
                                                                  attrs: {
                                                                    align:
                                                                      "right",
                                                                  },
                                                                },
                                                                [
                                                                  _vm.Doctordetailsshow ==
                                                                    true &&
                                                                  _vm.vitalsobj
                                                                    .staffDetails &&
                                                                  _vm.vitalsobj
                                                                    .staffDetails
                                                                    .registration_number
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm
                                                                                .vitalsobj
                                                                                .staffDetails
                                                                                .registration_number
                                                                            )
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ]
                                                              ),
                                                              _vm.Doctordetailsshow ==
                                                                true &&
                                                              _vm.location_tephonedetails
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          color:
                                                                            "#212529",
                                                                          "font-size":
                                                                            "14px",
                                                                          "font-weight":
                                                                            "500",
                                                                          "line-height":
                                                                            "140%",
                                                                        },
                                                                      attrs: {
                                                                        align:
                                                                          "right",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.location_tephonedetails
                                                                            ) +
                                                                              " "
                                                                          ),
                                                                          _c(
                                                                            "br"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm.vitalsobj
                                                                .businessappintmenturl &&
                                                              _vm.vitalsobj
                                                                .businessappintmenturl !=
                                                                "null" &&
                                                              !_vm.IsVS
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          color:
                                                                            "#212529",
                                                                          "font-size":
                                                                            "14px",
                                                                          "font-weight":
                                                                            "500",
                                                                          "line-height":
                                                                            "140%",
                                                                        },
                                                                      attrs: {
                                                                        align:
                                                                          "right",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "a",
                                                                        {
                                                                          ref: "Mini-site URL",
                                                                          staticStyle:
                                                                            {
                                                                              color:
                                                                                "rgb(33, 37, 41)",
                                                                              "text-decoration":
                                                                                "none",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              target:
                                                                                "_blank",
                                                                              href:
                                                                                "https://" +
                                                                                _vm
                                                                                  .vitalsobj
                                                                                  .businessappintmenturl,
                                                                              title:
                                                                                "Mini-site URL",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.vitalsobj.businessappintmenturl.split(
                                                                                "/"
                                                                              )[0]
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                            _c("table", { attrs: { width: "100%" } }, [
                              _c("thead", [
                                _c("tr", [
                                  _c("td", [
                                    _c("div", {
                                      class: _vm.printable_headerinves
                                        ? "page-header-space"
                                        : "page-header-nospace",
                                    }),
                                  ]),
                                ]),
                              ]),
                              _c("tbody", [
                                _c("tr", [
                                  _c("td", [
                                    _c("div", { staticClass: "page" }, [
                                      _c(
                                        "table",
                                        {
                                          staticStyle: {
                                            "border-bottom":
                                              "solid 1px #ccc !important",
                                          },
                                          attrs: {
                                            width: "100%",
                                            cellspacing: "0",
                                            cellpadding: "0",
                                            border: "0",
                                          },
                                        },
                                        [
                                          _c("tr", [
                                            _c(
                                              "td",
                                              {
                                                staticClass: "wrapper1",
                                                staticStyle: {
                                                  "border-bottom":
                                                    "1px solid #d4d5d7",
                                                },
                                                attrs: {
                                                  width: "70%",
                                                  valign: "top",
                                                  align: "left",
                                                },
                                              },
                                              [
                                                _c(
                                                  "table",
                                                  {
                                                    attrs: {
                                                      width: "100%",
                                                      cellspacing: "0",
                                                      cellpadding: "0",
                                                      border: "0",
                                                    },
                                                  },
                                                  [
                                                    _vm.vitalsobj
                                                      ? _c("tr", [
                                                          _vm.vitalsobj
                                                            .patientdetails
                                                            ? _c(
                                                                "td",
                                                                {
                                                                  staticStyle: {
                                                                    padding:
                                                                      "10px 0",
                                                                  },
                                                                  attrs: {
                                                                    valign:
                                                                      "top",
                                                                    align:
                                                                      "left",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          display:
                                                                            "block",
                                                                          float:
                                                                            "left",
                                                                          width:
                                                                            "100%",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              "font-weight":
                                                                                "500",
                                                                              "font-size":
                                                                                "14px",
                                                                              "line-height":
                                                                                "170%",
                                                                              width:
                                                                                "136px",
                                                                              display:
                                                                                "inline-block",
                                                                              float:
                                                                                "left",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "Patientname"
                                                                              )
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm
                                                                        .vitalsobj
                                                                        .patientdetails &&
                                                                      _vm
                                                                        .vitalsobj
                                                                        .patientdetails
                                                                        .name
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticStyle:
                                                                                {
                                                                                  "font-weight":
                                                                                    "400",
                                                                                  color:
                                                                                    "#333333",
                                                                                  width:
                                                                                    "auto",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                ":\n                                        " +
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .vitalsobj
                                                                                      .patientdetails
                                                                                      .name
                                                                                  )
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          display:
                                                                            "block",
                                                                          float:
                                                                            "left",
                                                                          width:
                                                                            "100%",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              "font-weight":
                                                                                "500",
                                                                              "font-size":
                                                                                "14px",
                                                                              "line-height":
                                                                                "170%",
                                                                              width:
                                                                                "136px",
                                                                              display:
                                                                                "inline-block",
                                                                              float:
                                                                                "left",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "RegistrationNo"
                                                                              )
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              "font-weight":
                                                                                "400",
                                                                              color:
                                                                                "#333333",
                                                                              width:
                                                                                "auto",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            ":\n                                        " +
                                                                              _vm._s(
                                                                                _vm
                                                                                  .vitalsobj
                                                                                  .patientdetails
                                                                                  .patient_RegId
                                                                              )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          display:
                                                                            "block",
                                                                          float:
                                                                            "left",
                                                                          width:
                                                                            "100%",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              "font-weight":
                                                                                "500",
                                                                              "font-size":
                                                                                "14px",
                                                                              "line-height":
                                                                                "170%",
                                                                              width:
                                                                                "136px",
                                                                              display:
                                                                                "inline-block",
                                                                              float:
                                                                                "left",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "AgeSex"
                                                                              )
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              "font-weight":
                                                                                "400",
                                                                              color:
                                                                                "#333333",
                                                                              width:
                                                                                "auto",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                        :\n                                        "
                                                                          ),
                                                                          _vm.ageCalculated !==
                                                                            "N/A" &&
                                                                          _vm
                                                                            .vitalsobj
                                                                            .patientdetails
                                                                            .gender
                                                                            ? _c(
                                                                                "span",
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      _vm.ageCalculated
                                                                                    ) +
                                                                                      "\n                                          /"
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm
                                                                                .vitalsobj
                                                                                .patientdetails
                                                                                .age &&
                                                                              _vm
                                                                                .vitalsobj
                                                                                .patientdetails
                                                                                .gender
                                                                            ? _c(
                                                                                "span",
                                                                                [
                                                                                  _vm._v(
                                                                                    "\n                                          " +
                                                                                      _vm._s(
                                                                                        _vm
                                                                                          .vitalsobj
                                                                                          .patientdetails
                                                                                          .age +
                                                                                          " yrs"
                                                                                      ) +
                                                                                      " / "
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _c(
                                                                                "span",
                                                                                [
                                                                                  _vm._v(
                                                                                    "N/A /"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                          _vm
                                                                            .vitalsobj
                                                                            .patientdetails
                                                                            .gender
                                                                            ? _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "c_name",
                                                                                  staticStyle:
                                                                                    {
                                                                                      "text-transform":
                                                                                        "capitalize",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      _vm
                                                                                        .vitalsobj
                                                                                        .patientdetails
                                                                                        .gender
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ])
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            !_vm.IsVS
                                              ? _c(
                                                  "td",
                                                  {
                                                    staticClass: "wrapper1",
                                                    staticStyle: {
                                                      padding:
                                                        "10px 0px 10px 0",
                                                      "border-bottom":
                                                        "1px solid #d4d5d7",
                                                    },
                                                    attrs: {
                                                      width: "30%",
                                                      valign: "top",
                                                      "text-align": "right",
                                                    },
                                                  },
                                                  [
                                                    _vm.getQRCode()
                                                      ? _c("img", {
                                                          staticStyle: {
                                                            float: "right",
                                                          },
                                                          attrs: {
                                                            src: _vm.getQRCode(),
                                                            width: "81",
                                                            height: "80",
                                                          },
                                                        })
                                                      : _c("img", {
                                                          staticClass:
                                                            "disable-holdsec",
                                                          staticStyle: {
                                                            float: "right",
                                                          },
                                                          attrs: {
                                                            src: "https://s3.amazonaws.com/genamet-static-uploads-dev/9c42767e-1559-426b-8c70-b54299e091dd/images/qr-code.gif",
                                                            width: "81",
                                                            height: "80",
                                                          },
                                                        }),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "table",
                                        {
                                          attrs: {
                                            width: "100%",
                                            border: "0",
                                            cellspacing: "0",
                                            cellpadding: "0",
                                          },
                                        },
                                        [
                                          _c("tr", [
                                            _c(
                                              "td",
                                              {
                                                staticClass: "wrapper",
                                                staticStyle: {
                                                  padding: "20px 0 20px 0",
                                                },
                                                attrs: {
                                                  align: "left",
                                                  valign: "top",
                                                  bgcolor: "#FFFFFF",
                                                },
                                              },
                                              [
                                                _vm.vitalsobj
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "body-text",
                                                        staticStyle: {
                                                          color: "#212529",
                                                          "font-size": "14px",
                                                          "line-height": "140%",
                                                          "text-transform":
                                                            "capitalize",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              "font-weight":
                                                                "500",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t("Date")
                                                              ) + ":"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          "\n                                " +
                                                            _vm._s(
                                                              _vm.vitalsobj
                                                                .modalencounterdate
                                                            ) +
                                                            "\n                              "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _c("h3", [_vm._v("Vitals")]),
                                      _c(
                                        "table",
                                        { staticClass: "vitals-table" },
                                        [
                                          _vm._m(3),
                                          _c(
                                            "tbody",
                                            _vm._l(
                                              _vm.vitalsTableRows,
                                              function (row, i) {
                                                return _c(
                                                  "tr",
                                                  {
                                                    key: i,
                                                    staticClass: "vitals-row",
                                                  },
                                                  [
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(row.height)
                                                      ),
                                                    ]),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(row.weight)
                                                      ),
                                                    ]),
                                                    _c("td", [
                                                      _vm._v(_vm._s(row.bmi)),
                                                    ]),
                                                    _c("td", [
                                                      _vm._v(_vm._s(row.bp)),
                                                    ]),
                                                    _c("td", [
                                                      _vm._v(_vm._s(row.heart)),
                                                    ]),
                                                    _c("td", [
                                                      _vm._v(_vm._s(row.resp)),
                                                    ]),
                                                    _c("td", [
                                                      _vm._v(_vm._s(row.o2)),
                                                    ]),
                                                    _c("td", [
                                                      _vm._v(_vm._s(row.temp)),
                                                    ]),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "table",
                                        {
                                          staticStyle: {
                                            "border-bottom":
                                              "1px solid #d4d5d7",
                                          },
                                          attrs: {
                                            width: "100%",
                                            border: "0",
                                            cellspacing: "0",
                                            cellpadding: "0",
                                            align: "center",
                                          },
                                        },
                                        [
                                          _vm.Doctordetailsshow == true
                                            ? _c("tr", [
                                                _c(
                                                  "td",
                                                  {
                                                    staticStyle: {
                                                      padding: "30px 0 15px 0",
                                                      margin: "0",
                                                    },
                                                    attrs: {
                                                      align: "right",
                                                      valign: "top",
                                                      bgcolor: "#FFFFFF",
                                                    },
                                                  },
                                                  [
                                                    _vm.fileUrl != ""
                                                      ? _c("img", {
                                                          attrs: {
                                                            src: _vm.fileUrl,
                                                            height: "50px",
                                                            width: "Auto",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _vm.Doctordetailsshow ==
                                                      true &&
                                                    _vm.vitalsobj &&
                                                    _vm.vitalsobj.staffDetails
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              width: "100%",
                                                              "text-align":
                                                                "right",
                                                              display: "block",
                                                              padding: "10px 0",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.vitalsobj
                                                                  .staffDetails
                                                                  .title
                                                              ) +
                                                                "\n                                " +
                                                                _vm._s(
                                                                  _vm.vitalsobj
                                                                    .staffDetails
                                                                    .first_name
                                                                ) +
                                                                " " +
                                                                _vm._s(
                                                                  _vm.vitalsobj
                                                                    .staffDetails
                                                                    .last_name
                                                                )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ])
                                            : _vm._e(),
                                          _vm.vitalsobj.footernote1
                                            ? _c("tr", [
                                                _c(
                                                  "td",
                                                  {
                                                    attrs: {
                                                      align: "center",
                                                      valign: "top",
                                                    },
                                                  },
                                                  [
                                                    _c("p", {
                                                      staticStyle: {
                                                        margin: "10px 0 10px",
                                                        "font-size": "12px",
                                                      },
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.vitalsobj
                                                            .footernote1
                                                        ),
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ]),
                              _c("tfoot", [
                                _c("tr", [
                                  _c("td", [
                                    _c("div", {
                                      class: _vm.printable_headerinves
                                        ? "page-footer-space"
                                        : "page-footer-nospace",
                                    }),
                                  ]),
                                ]),
                              ]),
                            ]),
                            _c(
                              "div",
                              {
                                class: _vm.printable_headerinves
                                  ? "page-footer"
                                  : "no-footer",
                              },
                              [
                                _vm.printable_headerinves
                                  ? _c("table", { attrs: { width: "100%" } }, [
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticStyle: { padding: "10px 0" },
                                            attrs: { align: "center" },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "body-text",
                                                staticStyle: {
                                                  color: "#212529",
                                                  "font-size": "13px",
                                                  "font-weight": "500",
                                                  "font-style": "normal",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Thisdocumentisdigitallysignedandhencenomanualsignatureisrequired"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          { attrs: { align: "center" } },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "font-size": "13px",
                                                  color: "#aaa",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("Poweredby"))
                                                ),
                                              ]
                                            ),
                                            _vm._m(4),
                                            _c("br"),
                                            _vm._m(5),
                                          ]
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticStyle: { margin: "0px auto" } }, [_vm._v("Send Email")]),
      _c(
        "button",
        {
          staticClass: "close",
          staticStyle: { top: "10px" },
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close",
          },
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "close-sec-hold", staticStyle: { right: "-15px" } },
      [
        _c(
          "button",
          {
            staticClass: "close pl-2",
            attrs: {
              type: "button",
              "data-dismiss": "modal",
              "aria-label": "Close",
            },
          },
          [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticStyle: {
          color: "#212529",
          "font-size": "14px",
          "font-weight": "500",
          "line-height": "140%",
        },
        attrs: { align: "right" },
      },
      [
        _c("span", [
          _vm._v(
            "\n                                Tmn 2012 0001692 ktk\n                              "
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", { staticClass: "vitals-header" }, [
        _c("th", [_vm._v("Height")]),
        _c("th", [_vm._v("Weight")]),
        _c("th", [_vm._v("BMI")]),
        _c("th", [_vm._v("Blood Pressure")]),
        _c("th", [_vm._v("Heart Rate")]),
        _c("th", [_vm._v("Respiratory Rate")]),
        _c("th", [_vm._v("O2 Sat")]),
        _c("th", [_vm._v("Temperature")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticStyle: { "text-decoration": "none" },
        attrs: { href: "https://www.genamet.com/", target: "_blank" },
      },
      [
        _c(
          "span",
          {
            staticStyle: {
              "font-size": "13px",
              color: "rgb(0, 86, 224)",
              "text-decoration": "none",
            },
          },
          [_vm._v("www.genamet.com")]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { staticStyle: { "margin-right": "10px" }, attrs: { href: "#" } },
      [
        _c("img", {
          staticStyle: { "padding-top": "10px" },
          attrs: {
            src: "https://s3.amazonaws.com/genamet-static-uploads-dev/9c42767e-1559-426b-8c70-b54299e091dd/images/powered-genamet.png",
          },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }